import { render, staticRenderFns } from "./ChatOrderProfileCustomFieldModalDetail.vue?vue&type=template&id=08ba1bcc&scoped=true&"
import script from "./ChatOrderProfileCustomFieldModalDetail.vue?vue&type=script&lang=js&"
export * from "./ChatOrderProfileCustomFieldModalDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderProfileCustomFieldModalDetail.vue?vue&type=style&index=0&id=08ba1bcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ba1bcc",
  null
  
)

export default component.exports